export const ACTION_CODE = 'DASHBOARD_ADMIN' + '_ACTION';
